import React, { useContext } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import i18next from "i18next";
import _ from "lodash";

import useStyles from "style/js-style/containers/administration/calculator/CalculatorDialogStyle";
import EAIcon from "components/common/EAIcon";
import {
  VariableContext,
} from "services/common/CalculatorUtils";
import CalculatorStandardInput from "../calculatorInputs/CalculatorStandardInput";
import TargetField from '../targetFields';

const Variable = ({
  fieldName,
  onRemove,
  validateName,
  onVariableChangeCallBack,
  readOnly = false
}) => {
  const { classes } = useStyles();

  let currentVariable = useWatch({ name: fieldName });

  const variableContext = React.useMemo(
    () => ({
      onVariableChangeCallBack: onVariableChangeCallBack,
      currentVariable: currentVariable,
    }),
    [
      onVariableChangeCallBack,
      currentVariable
    ]
  );

  return (
    <div className={classes.variableLineRoot}>
      {/* Suppression de la variable */}
      {!readOnly &&
        <EAIcon
          icon={"highlight_off"}
          className={classes.variableLineCrossIcon}
          onClick={() => onRemove()}
        />
      }

      <VariableContext.Provider value={variableContext}>
        <NameField fieldName={`${fieldName}.name`} validateName={validateName} readOnly={readOnly}/>
        <TargetField fieldName={`${fieldName}.targetField`} readOnly={readOnly}/>
      </VariableContext.Provider>
    </div>
  );
}

const NameField = ({ fieldName, validateName, readOnly }) => {
  const { classes } = useStyles();
  const formMethods = useFormContext();
  const {
    formState: { errors }
  } = formMethods;

  const { onVariableChangeCallBack, currentVariable } = useContext(VariableContext);

  return (
    <CalculatorStandardInput
      fieldName={`${fieldName}`}
      label={i18next.t("calculator.dialog.create.placeholder.variableName")}
      placeholder={i18next.t(`calculator.dialog.create.placeholder.variableName`)}
      validate={(value) => {
        return validateName(value, `${fieldName}`, currentVariable?.type);
      }}
      className={
        !!_.get(errors, `${fieldName}`)
          ? classes.variableInputError
          : classes.variableInput
      }
      onChange={
        (newValue) => {
          onVariableChangeCallBack(currentVariable, "name", newValue);
        }
      }
      variant="innerLabel"
      errorVariant="absolute"
      disabled={readOnly}
    />
  );
}

export default Variable;